import APIHandler from './APIHandler';

export default APIHandler;
